import React, { useContext, useEffect, useState, Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import {
    Button,
    Col,
    Container,
    Form,
    Row,
    Spinner,
    InputGroup,
} from 'react-bootstrap';

import AuthContext from '../../Context/authContext';
import { requestUserSignup } from '../../Services/api';
import Notification, { useNotification } from 'src/Components/Notification';
import './style.scss';


const SignupPage = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [country, setCountry] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [hasPasswordError, setHasPasswordError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { setIsAdmin } = useContext(AuthContext);
    const { notifySuccess, notifyError, onClose, notification } = useNotification();

    useEffect(() => {
        setIsAdmin(true);
    }, [setIsAdmin]);

    const validateForm = () => {
        return (
            email.length > 0 &&
            password.length > 0 &&
            country.length > 0 &&
            phone.length > 0 &&
            firstName.length > 0 &&
            lastName.length > 0
        );
    };

    const validatePassword = (text) => {
        setPassword2(text);

        if (password === text) {
            setHasPasswordError(false);
        } else {
            setHasPasswordError(true);
        }
    };

    const userSignup = async e => {
        e.preventDefault()
        setIsLoading(true);
        const data = {
            first_name: firstName,
            last_name: lastName,
            phone_no: phone,
            email: email,
            password: password,
            country: country,
        };
        const res = await requestUserSignup(data);

        if (res.status !== 201) {
            const err = res.response.data;
            const errMsg = Object.keys(err).map((key) => {
                return `${[key]}: ${err[key]}`;
            });
            notifyError({ message: errMsg });
            setIsLoading(false);
        } else {
            setIsLoading(false);
            notifySuccess({
                header: "Account created successfully!",
                message: (
                    <Fragment>
                        <p>Click on the login button to access your account.</p>
                        <hr />
                        <div className="d-flex justify-content-end">
                            <Button onClick={() => navigate('/login')} variant="outline-success">
                                Login
                            </Button>
                        </div>
                    </Fragment>
                ),
            });
        }
    };

    return (
        <>
            <Container className='sharedAuthStyles signupContainer'>
                <Notification id="signup-notif" onClose={onClose} {...notification} />
                <div className='header mb-5'>
                    <h4 className='text-secondary'>New here?</h4>
                    <p className='text-muted'>
                        Create an account to start checking out cool spots and also add your business
                    </p>
                </div>
                <Form onSubmit={userSignup}>
                    <Row className='mb-5'>
                        <Col xs={12} lg={6}>
                            <Form.Group controlId='formFirstName'>
                                <Form.Control
                                    autoFocus
                                    className='formInput text-dark'
                                    type='text'
                                    placeholder='First name'
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group controlId='formLastName'>
                                <Form.Control
                                    className='formInput text-dark'
                                    type='text'
                                    placeholder='Last name'
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mb-5'>
                        <Col xs={12} lg={6}>
                            <Form.Group controlId='formPhoneNo'>
                                <InputGroup>
                                    <Form.Select
                                        className='formInput text-dark'
                                        value={country}
                                        style={{maxWidth: '120px'}}
                                        onChange={(e) => setCountry(e.target.value)}
                                    >
                                        <option value="" disabled>Country</option>
                                        <option key="NG" label="NG" value="Nigeria" />
                                        <option key="US" label="US" value="United States" />
                                    </Form.Select>
                                    <Form.Control
                                        className='formInput text-dark'
                                        type="tel" 
                                        inputMode="numeric" 
                                        placeholder='Phone no'
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group controlId='formBasicEmail'>
                                <Form.Control
                                    className='formInput text-dark'
                                    type='email'
                                    placeholder='Email'
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mb-5'>
                        <Col xs={12} lg={6}>
                            <Form.Group controlId='formPassword'>
                                <Form.Control
                                    className='formInput text-dark'
                                    type='password'
                                    placeholder='Password'
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group controlId='formPassword2'>
                                <Form.Control
                                    className='formInput text-dark'
                                    type='password'
                                    placeholder='Re-type Password'
                                    value={password2}
                                    onChange={(e) => validatePassword(e.target.value)}
                                />
                            </Form.Group>
                            {hasPasswordError && (
                                <p style={{ color: "red", fontSize: 12, marginTop: 5 }}>
                                    Passwords does not match
                                </p>
                            )}
                        </Col>
                    </Row>
                    <div className='text-center'>
                        <Button
                            className='business submitButton mt-5'
                            type='submit'
                            disabled={!validateForm() || isLoading || hasPasswordError}
                        >
                            {isLoading && (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className='me-2'
                                />
                            )}
                            Create Account
                        </Button>
                    </div>
                </Form>
                <div>
                    <p className='text-center text-secondary mt-3'>
                        Already have an account?
                        <span>
                            <Button
                                variant='link'
                                className='px-1 signinLink'
                                onClick={() => navigate('/login')}
                            >
                                Sign in
                            </Button>
                        </span>
                    </p>
                </div>
            </Container>
        </>
    );
};

export default SignupPage;
